import React from 'react';
import { Link } from 'react-router-dom';
import ReactPlayer from 'react-player';
import { Typewriter } from 'react-simple-typewriter';
import { Row, Col, Card, Button } from 'react-bootstrap';
import Background from 'components/common/Background';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import UNASS_Teaser from 'assets/videos/UNASS_Presentation_1min.mp4'
import UNASS_Presentation from 'assets/videos/UNASS_Teaser_Mai2023.mp4'

import corner1 from 'assets/img/illustrations/corner-1.png';
import corner4 from 'assets/img/illustrations/corner-4.png';
import corner5 from 'assets/img/illustrations/corner-5.png';
import corner7 from 'assets/img/illustrations/corner-7.png';

import ConfigurationService from 'services/configurationService';

const LienHomePage = ({
    title,
    text,
    linkTarget,
    linkText,
    image = corner1,
    className
}) => (
    <Card className={`overflow-hidden ${className}`}>
        <Background image={image} className="p-x1 bg-card" />
        <Card.Body className="position-relative">
            <h5 className="text-warning">{title}</h5>
            <p className="fs-10 mb-0">
                {text}
            </p>
            <Button
                as={Link}
                variant="link"
                className="fs-10 text-warning mt-lg-3 ps-0"
                to={linkTarget}
            >
                {linkText}
                <FontAwesomeIcon icon="chevron-right" className="ms-1 fs-11" />
            </Button>
        </Card.Body>
    </Card>
);

const HomeScreen = () => {
    return (<>
        <center>
            <h3 className='mb-3 mt-3'>
                <Typewriter
                    words={["Un poste de secours ?", "Une formation ?", "Devenir bénévole ?", "Bienvenue à l'UNASS !"]}
                    loop={1}
                    cursor
                    cursorStyle="|"
                    typeSpeed={30}
                    deleteSpeed={20}
                    delaySpeed={1000}
                />
            </h3>
        </center>

        <Row className="mt-3 align-items-center">
            <Col md={3}>
                <LienHomePage
                    title={"Un poste de secours ?"}
                    text={"Besoin de sécuriser un évènement ?"}
                    linkTarget={'/demandeDPS'}
                    linkText={"Demander un DPS"}
                    image={corner7}
                    className={'mb-3'}
                />
            </Col>
            <Col md={3}>
                <LienHomePage
                    title={"Une formation ?"}
                    text={"Grand public ? Professionnelle ? Spécialisée ?"}
                    linkTarget={ConfigurationService.config['lienExterneFormation']}
                    linkText={"En savoir plus"}
                    image={corner5}
                    className={'mb-3'}
                />
            </Col>
            <Col md={3}>
                <LienHomePage
                    title={"Devenir bénévole ?"}
                    text={"Venir se former et exercercer à l'UNASS"}
                    linkTarget={'/recrutement'}
                    linkText={"Nous rejoindre"}
                    image={corner1}
                    className={'mb-3'}
                />
                </Col>
            <Col md={3}>
                <LienHomePage
                    title={"Nous contacter"}
                    text={"L'UNASS est là pour vous"}
                    linkTarget={'/contact'}
                    linkText={"Nous contacter"}
                    image={corner4}
                    className={'mb-3'}
                />
            </Col>
            <center>
                <Col md={12} className='mb-3'>
                    <ReactPlayer
                        controls={true}
                        url={UNASS_Teaser}
                        width="70%"
                        height="70%"
                    />
                </Col>
            </center>
        </Row>

        <Card>
            <Card.Header>
                <h5 className="mb-0">Notre association</h5>
            </Card.Header>
            <Card.Body className="bg-body-tertiary pb-0">
                <p>
                    L'UNASS Rhône-Loire-Ain: Première association du mouvement UNASS créée à Lyon en 1966.<br/>
                    Notre activité s’étend aujourd'hui sur les départements du Rhône, de la Loire de l'Ain et parfois bien au-delà.<br/>
                </p>

                <h5 className='mt-3'>Les Missions de Sécurité Civile</h5>
                <p>
                    Profitez de notre forte expérience et confiez nous les <Link to='/demandeDPS'>Dispositifs Prévisionnels de Secours</Link> de vos événements sportifs, culturels, humanitaires.
                </p>

                <h5 className='mt-3'>Les Formations</h5>
                <p>
                    <ul>
                        <li>Initiation aux Gestes Qui Sauvent (GQS),</li>
                        <li>Premiers Secours Citoyen (PSC),</li>
                        <li>Secouristes Sauveteur du Travail SST - Secours et Prévention des risques</li>
                        <li>Premiers Secours en Equipe (PSE),</li>
                        <li>Formateur,</li>
                        <li>Des formations sur mesure pour répondre à vos besoins spécifiques</li>
                    </ul>
                    <p><Link to={ConfigurationService.config['lienExterneFormation']}>En savoir plus sur les formations</Link></p>
                </p>

                <h5 className='mt-3'>Devenir Bénévole</h5>
                <p>
                    <Link to='/recrutement'>Rejoignez nos équipes de secours</Link>, nous assurons votre formation !
                </p>

                <h5 className='mt-3'>L'UNASS vous accueille</h5>
                <p className='mb-3'>    
                    Notre siège, située 100 route de Vienne 69008 Lyon, est ouvert au public le lundi, mardi, jeudi et vendredi de 9h00 à 12h et de 14h00 à 17h00 (fermé le mercredi). N'hésitez pas à venir nous rencontrer !
                </p>

                <p className='mt-3'>
                    <center>
                        <ReactPlayer
                            controls={true}
                            url={UNASS_Presentation}
                            width="75%"
                            height="75%"
                        />
                    </center>
                </p>
            </Card.Body>
        </Card>
    </>);
};

export default HomeScreen;